import { Component, Input } from "@angular/core";

import { KpiStatus } from "src/app/models/kpi/kpi.model";

@Component({
  selector: "app-kpi",
  templateUrl: "./kpi.component.html",
  styleUrls: ["./kpi.component.scss"],
})
export class KpiComponent {
  @Input() status: KpiStatus;
  @Input() title: any;
  @Input() description: string;
  @Input() icon: string;
  @Input() value: number | string;
  @Input() totalValue: number;
  @Input() unit: string;
  @Input() progressValue: number;
  @Input() dateValue: string;

  constructor() {}
}
